import PaymentProviders from '@/common/components/PaymentProviders/PaymentProviders';
import {
  FooterInfoBoxHeader,
  FooterInfoBoxText,
  FooterInfoBoxWrapper,
} from '@/modules/ProductPage/components/Footer/FooterInfoBox.styled';

const FooterSecurePaymentBox = () => {
  return (
    <FooterInfoBoxWrapper>
      <FooterInfoBoxHeader>Secure payments</FooterInfoBoxHeader>
      <FooterInfoBoxText>100% Secure payment with 256-bit SSL Encryption</FooterInfoBoxText>
      <PaymentProviders className="payment-images" />
    </FooterInfoBoxWrapper>
  );
};

export default FooterSecurePaymentBox;
